exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-downloads-econtra-tsx": () => import("./../../../src/pages/downloads/econtra.tsx" /* webpackChunkName: "component---src-pages-downloads-econtra-tsx" */),
  "component---src-pages-hcp-tsx": () => import("./../../../src/pages/hcp.tsx" /* webpackChunkName: "component---src-pages-hcp-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

